import styled, { css } from 'styled-components';
import { Flex } from '../../../../../common/common-components.styled';

export const StyledFilterStatusesGroupContainer = styled(Flex)<{ active: boolean }>`
  padding: 5px;
  align-items: center;
  cursor: pointer;
  margin-bottom: 5px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.extraLightBlue};
  }
  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.colors.extraLightBlue};
    `};
`;
